import React, {useEffect, useState} from "react";
import {
    TextField,
    Button,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    CircularProgress, Autocomplete,
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {setSuccess} from "../../../Redux/AlertReducer";
import {useDispatch} from "react-redux";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";

export const FormAddShop = ({
                                groups,
                                isGroupsLoading,
                            }) => {
    const [loadingSubmit, setloadingSubmit] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedGroup, setSelectedGroup] = useState([]);
    const itemsPerPage = 25;
    const [groupsPage, setGroupsPage] = useState(1);
    const [groupSearchQuery, setGroupSearchQuery] = useState("");
    const paginatedGroups = groups.slice(0, groupsPage * itemsPerPage);
    const filteredGroups = groups.filter((Group) =>
        Group.name.toLowerCase().includes(groupSearchQuery.toLowerCase())
    );
    const displayedGroups = groupSearchQuery
        ? filteredGroups
        : paginatedGroups;



    const [formData, setFormData] = useState({
        name: "",
        description: "",
        picture: null,
        active: 1,
        FiledDescription: 1,
        FiledTitle: 1,
        FiledImage: 1,
        with_type: 1,
        FiledPanel: 1,
        with_groups: 0,
        unit_price: 0,
        min_unit_price: 0,
        max_unit_price: 0,
        max_count: 0,
        min_count: 0,
        order: 1,
        groups: []
    });

    const handleGroupChange = (event, newValue) => {
        setSelectedGroup(newValue);
        // Extract only Group IDs
        const GroupIds = newValue.map(Group => Group.id);
        setFormData(prev => ({ ...prev, groups: GroupIds }));
    };

    const handleInputChange = (e) => {
        const {name, value, type, files} = e.target;
        if (type === "file") {
            setFormData((prev) => ({
                ...prev,
                picture: files[0],
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleRadioChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        setloadingSubmit(true);
        e.preventDefault();

        const formDataToSend = new FormData();
        for (let key in formData) {
            if (formData[key] !== null && formData[key] !== 'groups') {
                formDataToSend.append(key, formData[key]);
            }
        }
        formData.groups.forEach(GroupId => {
            formDataToSend.append('groups[]', GroupId);
        });

        try {
            const {result, response, message} = await Helper.Post({
                url: api_Routes.ShopAds.Add,
                data: formDataToSend,
                isFormData: true,
            });

            setloadingSubmit(false);
            if (response) {
                dispatch(setSuccess(true));
                navigate("/Shop-ADS");
            }
        } catch (error) {
            console.error("An error occurred during form submission:", error);
            setloadingSubmit(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <TextField
                fullWidth
                margin="normal"
                label="Name"
                name="name"
                required
                autoComplete="off"
                value={formData.title}
                onChange={handleInputChange}
                variant="outlined"
            />

            <TextField
                fullWidth
                margin="normal"
                label="Description"
                name="description"
                multiline
                rows={2}
                autoComplete="off"
                value={formData.description}
                onChange={handleInputChange}
                variant="outlined"
            />

            <TextField
                fullWidth
                margin="normal"
                label="Upload Image"
                name="file"
                type="file"
                InputLabelProps={{shrink: true}}
                onChange={handleInputChange}
                variant="outlined"
                inputProps={{
                    accept: "image/*",
                }}
            />
            {
                formData.with_type === "0"  &&
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                    <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                        <TextField
                            type={'number'}
                            fullWidth
                            margin="normal"
                            label="Min Count"
                            name="min_count"
                            required
                            autoComplete="off"
                            value={formData.min_count}
                            onChange={handleInputChange}
                            variant="outlined"
                        />
                    </div>
                    <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                        <TextField
                            type={'number'}
                            fullWidth
                            margin="normal"
                            label="Max Count"
                            name="max_count"
                            required
                            autoComplete="off"
                            value={formData.max_count}
                            onChange={handleInputChange}
                            variant="outlined"
                        />
                    </div>
                    <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                        <TextField
                            type={'number'}
                            fullWidth
                            margin="normal"
                            label="Unit Price"
                            name="unit_price"
                            required
                            autoComplete="off"
                            value={formData.unit_price}
                            onChange={handleInputChange}
                            variant="outlined"
                        />
                    </div>
                    <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                        <TextField
                            type={'number'}
                            fullWidth
                            margin="normal"
                            label="Min Unit Price"
                            name="min_unit_price"
                            required
                            autoComplete="off"
                            value={formData.min_unit_price}
                            onChange={handleInputChange}
                            variant="outlined"
                        />
                    </div>
                    <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                        <TextField
                            type={'number'}
                            fullWidth
                            margin="normal"
                            label="Max Unit Price"
                            name="max_unit_price"
                            required
                            autoComplete="off"
                            value={formData.max_unit_price}
                            onChange={handleInputChange}
                            variant="outlined"
                        />
                    </div>
                </div>
            }
            {
                formData.with_groups === "1"  &&
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                    <div className="w-full">
                        <Autocomplete
                            multiple
                            disablePortal
                            loading={isGroupsLoading}
                            options={displayedGroups}
                            getOptionLabel={(option) => option.name || ""}
                            onChange={handleGroupChange}
                            onInputChange={(event, value) => setGroupSearchQuery(value)}
                            renderInput={(params) => (
                                <TextField {...params} label="Group" variant="outlined"/>
                            )}
                            ListboxProps={{
                                onScroll: (event) => {
                                    const listboxNode = event.currentTarget;
                                    if (
                                        listboxNode.scrollTop + listboxNode.clientHeight >=
                                        listboxNode.scrollHeight - 3
                                    ) {
                                        setGroupsPage((prevPage) => prevPage + 1);
                                    }
                                },
                            }}
                        />
                    </div>
                </div>
            }


            <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                    <div className="flex items-center justify-start gap-x-3">
                        <FormLabel sx={{fontWeight: "bold"}} component="legend">
                            Image Required:
                        </FormLabel>
                        <RadioGroup
                            name="FiledImage"
                            value={formData.FiledImage}
                            onChange={handleRadioChange}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
                            <FormControlLabel value="0" control={<Radio/>} label="No"/>
                        </RadioGroup>
                    </div>

                    <div className="flex items-center justify-start gap-x-3">
                        <FormLabel sx={{fontWeight: "bold"}} component="legend">
                            Active:
                        </FormLabel>
                        <RadioGroup
                            name="active"
                            value={formData.active}
                            onChange={handleRadioChange}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
                            <FormControlLabel value="0" control={<Radio/>} label="No"/>
                        </RadioGroup>
                    </div>
                </div>

                <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                    <div className="flex items-center mt-2 justify-start gap-x-3">
                        <FormLabel sx={{fontWeight: "bold"}} component="legend">
                            Description Required:
                        </FormLabel>
                        <RadioGroup
                            name="FiledDescription"
                            value={formData.FiledDescription}
                            onChange={handleRadioChange}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
                            <FormControlLabel value="0" control={<Radio/>} label="No"/>
                        </RadioGroup>
                    </div>

                    <div className="flex items-center justify-start gap-x-3">
                        <FormLabel sx={{fontWeight: "bold"}} component="legend">
                            Title Required:
                        </FormLabel>
                        <RadioGroup
                            name="FiledTitle"
                            value={formData.FiledTitle}
                            onChange={handleRadioChange}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
                            <FormControlLabel value="0" control={<Radio/>} label="No"/>
                        </RadioGroup>
                    </div>
                </div>


                <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                    <div className="flex items-center mt-2 justify-start gap-x-3">
                        <FormLabel sx={{fontWeight: "bold"}} component="legend">
                            With Types:
                        </FormLabel>
                        <RadioGroup
                            name="with_type"
                            value={formData.with_type}
                            onChange={handleRadioChange}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
                            <FormControlLabel value="0" control={<Radio/>} label="No"/>
                        </RadioGroup>
                    </div>
                </div>
                <div className="grid grid-cols-1 items-center justify-between gap-x-3">
                    <div className="flex items-center mt-2 justify-start gap-x-3">
                        <FormLabel sx={{fontWeight: "bold"}} component="legend">
                            With Groups:
                        </FormLabel>
                        <RadioGroup
                            name="with_groups"
                            value={formData.with_groups}
                            onChange={handleRadioChange}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
                            <FormControlLabel value="0" control={<Radio/>} label="No"/>
                        </RadioGroup>
                    </div>
                </div>
                <div className="grid grid-cols-1 items-center justify-between gap-x-3">

                    <div className="flex items-center mt-2 justify-start gap-x-3">
                        <FormLabel sx={{fontWeight: "bold"}} component="legend">
                            Panel Url Required:
                        </FormLabel>
                        <RadioGroup
                            name="FiledPanel"
                            value={formData.FiledPanel}
                            onChange={handleRadioChange}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
                            <FormControlLabel value="0" control={<Radio/>} label="No"/>
                        </RadioGroup>
                    </div>

                </div>
                <div className="grid grid-cols-1 items-center justify-between gap-x-3">

                    <div className="flex items-center mt-2 justify-start gap-x-3">
                        <TextField
                            margin="normal"
                            label="Order"
                            name="order"
                            required
                            type={'number'}
                            autoComplete="off"
                            value={formData.order}
                            onChange={handleInputChange}
                            variant="outlined"
                        />
                    </div>

                </div>
            </div>

            {loadingSubmit ? (
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{
                        display: "flex",
                        marginTop: 2,
                        width: "20%",
                        marginX: "auto",
                        fontWeight: "bold",
                        justifyContent: "center",
                    }}
                >
                    <CircularProgress size={24} color="inherit"/>
                </Button>
            ) : (
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{
                        display: "block",
                        marginTop: 2,
                        width: "20%",
                        marginX: "auto",
                        fontWeight: "bold",
                    }}
                >
                    Submit
                </Button>
            )}
        </form>
    );
};
